import { OPERATORS, hasOptions, operatorLabel, type Condition, type ConditionValue, type Question } from '@survey/core';
import type { MessageKey, Vars } from '../../i18n';

type T = (key: MessageKey, vars?: Vars) => string;

/** A condition's value as the builder shows it: the option's label for choice questions, Yes/No for booleans. */
export function valueLabel(src: Question | undefined, value: ConditionValue | undefined, t: T): string {
  if (src && hasOptions(src.type)) return src.options?.find((o) => o.id === value)?.label ?? String(value ?? '');
  if (typeof value === 'boolean') return value ? t('common.yes') : t('common.no');
  return String(value ?? '');
}

/** "is “A”", "is answered": how a condition reads after its subject. */
export function conditionPhrase(src: Question | undefined, operator: Condition['operator'], value: ConditionValue | undefined, t: T, locale: 'en' | 'id'): string {
  const needsValue = OPERATORS.find((o) => o.op === operator)?.needsValue ?? true;
  const op = operatorLabel(operator, locale);
  return needsValue ? `${op} “${valueLabel(src, value, t)}”` : op;
}
